












































import Vue from "vue";
import GaIcon from "./GaIcon.vue";
import { SIZE, useGenAiPalette } from "../data/design";

/** gen-ai-ui `ViewModeToggle`: bar graph (the list) or chart graph (the donut) */
export default Vue.extend({
  components: { GaIcon },
  props: {
    value: { type: String, default: "list" },
  },
  setup() {
    return {
      T: useGenAiPalette(),
      S: SIZE,
      options: [
        { value: "list", label: "Bar graph", icon: "chart-column" },
        { value: "chart", label: "Chart graph", icon: "chart-pie" },
      ],
    };
  },
});
